import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-politica-privacidad-modal',
  templateUrl: './politica-privacidad-modal.component.html',
  styleUrls: ['./politica-privacidad-modal.component.scss']
})
export class PoliticaPrivacidadModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PoliticaPrivacidadModalComponent>,
  ) { }

  ngOnInit(): void {
  }

  cancelar(): void {
    this.dialogRef.close();
  }

}
